module.exports = __webpack_public_path__ + "static/media/34DSS9.9538c933.jpg";